import { Component, ViewChild, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, CheckboxComponent, ModalComponent, ModalFooterDirective, ModalService } from 'mbs-ui-kit';
import { TwoFactorEnableModalComponent } from 'mbs-ui-shared@components';
import { ApplicationStateFacade } from 'mbs-ui-shared@facades/application.facade';
import { UiStorageKey } from 'mbs-ui-shared@models';
import { noop, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@UntilDestroy()
@Component({
  imports: [ButtonComponent, FormsModule, ReactiveFormsModule, I18NextPipe, ModalComponent, CheckboxComponent, ModalFooterDirective],
  selector: 'mbs-force-msp-2fa',
  templateUrl: './force-msp-2fa-modal.component.html'
})
export class ForceMSP2FaModalComponent {
  private modalService = inject(ModalService);
  private applicationStateFacade = inject(ApplicationStateFacade);

  public confirmationCheckbox = new FormControl(false);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public onForceMSPAppButtonClick() {
    const modal = this.modalService.openRef(TwoFactorEnableModalComponent, {
      data: {
        title: 'Enable Two-Factor Authentication',
        isForceMSP: true
      }
    });

    modal.componentInstance.showThirdPartyAuthButton = false;

    modal.result.then(() => this.baseModal.save()).catch(noop);
  }

  public closeModal() {
    const query$ = this.confirmationCheckbox.value
      ? this.applicationStateFacade.updateStorageSetting(UiStorageKey.HideMSP2FAModal, 'true')
      : of(null);

    query$
      .pipe(
        untilDestroyed(this),
        catchError(() => of(null))
      )
      .subscribe({
        next: () => {
          this.baseModal.close();
        }
      });
  }
}
